var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpcomingFeteDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 352,
    height: 241,
    fill: "none",
    viewBox: "0 0 352 241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M0 12.804c0-6.627 5.373-12 12-12h328c6.627 0 12 5.373 12 12v216c0 6.628-5.373 12-12 12H12c-6.627 0-12-5.372-12-12v-216Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 134.251,
    height: 147.547,
    x: 97,
    y: 52.475,
    fill: "#EAECF0",
    rx: 16,
    transform: "rotate(-3.764 97 52.475)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 134.251,
    height: 147.547,
    x: 116.301,
    y: 38.804,
    fill: "#fff",
    rx: 16
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 42.034,
    height: 8.149,
    x: 130.455,
    y: 53.532,
    fill: "#B2B2B2",
    rx: 4.075
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 42.034,
    height: 8.149,
    x: 130.455,
    y: 86.559,
    fill: "#B2B2B2",
    rx: 4.075
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 42.034,
    height: 8.149,
    x: 130.455,
    y: 119.585,
    fill: "#B2B2B2",
    rx: 4.075
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 103.369,
    height: 5.576,
    x: 130.455,
    y: 66.829,
    fill: "#E5E5E5",
    rx: 2.788
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 103.369,
    height: 5.576,
    x: 130.455,
    y: 99.855,
    fill: "#E5E5E5",
    rx: 2.788
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 128.675,
    height: 33.026,
    x: 132.171,
    y: 134.597,
    fill: "#fff",
    stroke: "#D92D20",
    strokeDasharray: "8 9",
    strokeLinecap: "round",
    strokeWidth: 3,
    rx: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 259.13,
    cy: 135.455,
    r: 15.87,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D92D20",
    d: "M259.13 151.325c-8.765 0-15.87-7.105-15.87-15.87 0-8.765 7.105-15.87 15.87-15.87 8.765 0 15.87 7.105 15.87 15.87 0 8.765-7.105 15.87-15.87 15.87Zm-1.587-11.109v3.174h3.174v-3.174h-3.174Zm0-12.696v9.522h3.174v-9.522h-3.174Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingFeteDraft);
export default __webpack_public_path__ + "static/media/upcoming-fete-draft.57900850c9bd8fd175be707c50fd9c35.svg";
export { ForwardRef as ReactComponent };